import { PRODUCTS } from '../data/products';
import ProductCard from './ProductCard';
import WaitlistCta from './WaitlistCta';
import styles from './ProductsSection.module.css';

export default function ProductsSection({ onOpenWaitlist }) {
  return (
    <section className={styles.section}>
      <div className={styles.border}>
        <div className={styles.header}>
          <span className={styles.index}>[ 02 ]</span>
          <h2 className={styles.title}>The Compound Stack</h2>
        </div>

        <p className={styles.intro}>
          Six infrastructure primitives, designed together, for the velocity and
          volume of AI-generated code. Every layer is API-first, fully
          programmable, and built to operate at machine speed.
        </p>

        <div className={styles.grid}>
          {PRODUCTS.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>

        <div className={styles.cta}>
          <WaitlistCta onOpen={onOpenWaitlist} />
        </div>
      </div>
    </section>
  );
}
